import React from 'react';
import { PageWrapper } from '../../Styles/style';
import SmoothScroll from '../../Components/GsapSmoothScroll';
import CYAHeader from '../../Sections/CYA/S1-CYA';
import FooterCYA from '../../Sections/CYA/S2-Footer';
import LockerMenu from '../../Components/LockerMenu';
import PaymentSuccessful from '../../Sections/PaymentMethod/PaymentSuccessful';


const PayemntSuccess = () => {
  return (
    <PageWrapper>
        <LockerMenu/>
        <PaymentSuccessful/>
        <FooterCYA/>
    </PageWrapper>
   
  );
};

export default PayemntSuccess;
